"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.attach_to_element = exports.init = void 0;
var csrf_token_1 = require("../utils/csrf-token");
var csrf = (0, csrf_token_1.get_csrf_token)();
function init(root) {
    if (root === void 0) { root = window.document.body; }
    var api_hit_elements = root.querySelectorAll("[data-component=api-hit]");
    for (var i = 0; i < api_hit_elements.length; ++i) {
        var api_hit_element = api_hit_elements.item(i);
        if (!(api_hit_element instanceof HTMLElement))
            continue;
        attach_to_element(api_hit_element);
    }
}
exports.init = init;
function attach_to_element(element) {
    if (element.getAttribute('data-component') !== 'api-hit')
        return;
    var href = element.getAttribute('data-href');
    if (!href)
        return;
    element.addEventListener('click', send_api_request_template_func(href, csrf));
}
exports.attach_to_element = attach_to_element;
function send_api_request_template_func(href, csrf) {
    return function () {
        fetch(href, {
            headers: {
                'X-CSRF-Token': csrf,
            }
        }).catch(function (error) {
            console.log("Failed to hit the server", error);
        });
    };
}
